<template>
  <el-popover
    placement="bottom-start"
    width="600"
    trigger="click"
    v-model="show">
    <div v-clickoutside="handleOutside" class="columns-setting">
      <div class="setting-header">
        筛选显示指标
      <i class="close el-icon-close" @click="close"></i>

      </div>
      <div class="setting-content">
        <el-checkbox-group v-model="checkedColumns" :min="1" @change="handleCheckedCitiesChange">
          <el-checkbox  v-for="obj in tableColumnsClone" :label="obj.name" :key="obj.name">{{obj.title.split(',')[0]}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="setting-footer">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-button class="right" type="primary" size="mini" @click="confirm" >确定</el-button>
      </div>

    </div>
    <span class="table-tip" slot="reference" v-if="showColumnSetting" :style="{left: showColumnExp?'105px': '15px', top:customTable? '-15px': '1px'}">
        <i class="iconfont icon-yingyongguanli1"></i>
        <span>筛选显示指标</span>
    </span>
  </el-popover>
</template>
<script>
  import { mapGetters } from 'vuex'
  import clickoutside from 'element-ui/lib/utils/clickoutside.js'
  export default {
    name: 'column-setting',
    directives: { clickoutside },
    computed: {
      ...mapGetters([
        'userId'
      ]),
      localKey() {
        return this.userId + '_' + this.code
      }
    },
    props: {
      customTable: {
        default: false
      },
      showColumnExp: {
        default: true
      },
      showColumnSetting: {
        default: false
      },
      tableColumns: {
        type: Array,
        required: true
      },
      code: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        tableColumnsClone: [],
        checkedColumns: [],
        isIndeterminate: true,
        checkAll: false,
        show: false
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.tableColumns.forEach((item) => {
          if (item && !item.hidden) {
            this.tableColumnsClone.push(item)
          }
        })
        this.getCheckedArrayFormCathe()
      },
      getCheckedArrayFormCathe() {
        const checkedArray = localStorage.getItem(this.localKey)
        if (checkedArray) { // 缓存中有选中的选项则使用缓存中的
          try { // 防止修改缓存数据造成失败
            this.checkedColumns = JSON.parse(checkedArray)
          } catch (e) {
            console.log('获取' + this.localKey + '选中项失败')
          }
          this.resetOriginCloumns()
        } else { // 没有缓存则显示全部
          this.handleCheckAllChange()
        }
      },
      close() {
        this.show = false
        this.getCheckedArrayFormCathe()
      },
      handleOutside() {
        this.close()
      },
      handleCheckAllChange() {
        if (this.checkedColumns.length !== this.tableColumnsClone.length) {
          this.checkedColumns = this.tableColumnsClone.map((item) => {
            return item.name
          })
        }
        this.checkAll = true
        this.isIndeterminate = false
      },
      handleCheckedCitiesChange(value) {
        const checkedCount = value.length
        this.checkAll = checkedCount === this.tableColumnsClone.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableColumnsClone.length
      },
      resetOriginCloumns() {
        console.log(this.userId)
        const checkedObj = {}
        this.checkedColumns.forEach((item) => {
          checkedObj[item] = true
        })
        const that = this
        const length = this.tableColumns.length
        for (let i = 0; i < length; i++) {
          const item = this.tableColumns[i]
          if (item.name && checkedObj[item.name]) {
            that.$set(item, 'hidden', false)
          } else {
            that.$set(item, 'hidden', true)
          }
        }
      },
      confirm() {
        this.resetOriginCloumns()
        localStorage.setItem(this.localKey, JSON.stringify(this.checkedColumns))
        this.close()
      }
    }

  }
</script>
<style scoped lang="scss">
  .columns-setting{
    background-color: #FFFFFF;
    margin: -12px -20px -15px -20px;
    padding-left: 20px;
    box-sizing: border-box;
    .setting-header{
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      font-size: 14px;
      color: #111111;
      background-color: #f9f9f9;
      .close{
        float: right;
        margin-right: 20px;
        margin-top: 10px;
      }
    }

    .setting-content{
      padding-top: 4px;
      padding-bottom: 20px;
    }
    .setting-footer{
      height: 50px;
      line-height: 50px;
      margin-right: 20px;
      box-sizing: border-box;
      border-top: 1px solid #f9f9f9;
      .el-checkbox{
        margin-top: 0px;
      }
      .right{
        margin-top: 10px;
        float: right;
      }
    }
    .el-checkbox{
      width: 33%;
      margin-top: 6px;
    }
    .el-checkbox+.el-checkbox {
      margin-left: 0px;
    }
  }
  .table-tip{
    color: #00a0e9;
    font-size: 20px;
    position: absolute;
    left:105px;
    top:1px;
    z-index: 99;
      span{
        font-size: 14px;
        color: #111111;
      }
  }

</style>



// WEBPACK FOOTER //
// src/views/report/components/base/columnSetting.vue